import * as ChatOrigins from './constants';

export const acquisitionMappings = (url: string) => {
  if (/\/acquisition|procurement/.test(url)) {
    return [
      [
        /\/((acquisition|procurement)\/personal-details\/summary)(\?|\/|#|$)/,
        ChatOrigins.ACQUISITION_ORIGIN_PERSONAL_DETAILS_SUMMARY,
      ],
      [
        /\/((acquisition|procurement)\/account)(\?|\/|#|$)/,
        ChatOrigins.ACQUISITION_ORIGIN_PERSONAL_DETAILS_SUMMARY,
      ],
      [
        /\/((acquisition|procurement)\/personal-details\/entry)(\?|\/|#|$)/,
        ChatOrigins.ACQUISITION_ORIGIN_PERSONAL_DETAILS_ENTRY,
      ],
      [
        /\/((acquisition|procurement)\/personal-details)(\?|\/|#|$)/,
        ChatOrigins.ACQUISITION_ORIGIN_PERSONAL_DETAILS_HOME,
      ],
      [
        /\/((acquisition|procurement)\/payment-options\/type)(\?|\/|#|$)/,
        ChatOrigins.ACQUISITION_ORIGIN_PAYMENT_OPTIONS_TYPE,
      ],
      [
        /\/((acquisition|procurement)\/payment-options\/build-my-deal)(\?|\/|#|$)/,
        ChatOrigins.ACQUISITION_ORIGIN_PAYMENT_OPTIONS_BUILD_DEAL,
      ],
      [
        /\/((acquisition|procurement)\/payment-options\/third-party-details)(\?|\/|#|$)/,
        ChatOrigins.ACQUISITION_ORIGIN_PAYMENT_OPTIONS_THIRD_PARTY,
      ],
      [
        /\/((acquisition|procurement)\/gap\/available)(\?|\/|#|$)/,
        ChatOrigins.ACQUISITION_ORIGIN_GAP_AVAILABLE,
      ],
      [
        /\/((acquisition|procurement)\/gap\/unavailable)(\?|\/|#|$)/,
        ChatOrigins.ACQUISITION_ORIGIN_GAP_UNAVAILABLE,
      ],
      [
        /\/((acquisition|procurement)\/trade-in\/get-value)(\?|\/|#|$)/,
        ChatOrigins.ACQUISITION_ORIGIN_TRADE_GET_VALUE,
      ],
      [
        /\/((acquisition|procurement)\/trade-documentation)(\?|\/|#|$)/,
        ChatOrigins.ACQUISITION_ORIGIN_TRADE_GET_VALUE,
      ],
      [
        /\/((acquisition|procurement)\/trade-in\/valued)(\?|\/|#|$)/,
        ChatOrigins.ACQUISITION_ORIGIN_TRADE_VALUED,
      ],
      [
        /\/((acquisition|procurement)\/trade-in\/decline-reason)(\?|\/|#|$)/,
        ChatOrigins.ACQUISITION_ORIGIN_TRADE_DECLINED_REASON,
      ],
      [
        /\/((acquisition|procurement)\/trade-in\/declined)(\?|\/|#|$)/,
        ChatOrigins.ACQUISITION_ORIGIN_TRADE_DECLINED,
      ],

      [
        /\/((acquisition|procurement)\/transfer-method\/edit-delivery-address)(\?|\/|#|$)/,
        ChatOrigins.ACQUISITION_ORIGIN_TRANSFER_METHOD_EDIT_DELIVERY_ADDRESS,
      ],
      [
        /\/((acquisition|procurement)\/transfer-method)(\?|\/|#|$)/,
        ChatOrigins.ACQUISITION_ORIGIN_TRANSFER_METHOD_DEFAULT,
      ],
      [
        /\/((acquisition|procurement)\/carvana-protection\/ancillary-products)(\?|\/|#|$)/,
        ChatOrigins.ACQUISITION_ORIGIN_ANCILLARY,
      ],
      [
        /\/((acquisition|procurement)\/carvana-protection\/missing-personal-details)(\?|\/|#|$)/,
        ChatOrigins.ACQUISITION_ORIGIN_MISSING_PERSONAL_DETAILS,
      ],
      [
        /\/((acquisition|procurement)\/carvana-protection\/unavailable)(\?|\/|#|$)/,
        ChatOrigins.ACQUISITION_ORIGIN_PROTECTION_UNAVAILABLE,
      ],
      [
        /\/((acquisition|procurement)\/drivers-license\/upload)(\?|\/|#|$)/,
        ChatOrigins.ACQUISITION_ORIGIN_DRIVER_LICENSE_UPLOAD,
      ],
      [
        /\/((acquisition|procurement)\/drivers-license\/pending)(\?|\/|#|$)/,
        ChatOrigins.ACQUISITION_ORIGIN_DRIVER_LICENSE_PENDING,
      ],
      [
        /\/((acquisition|procurement)\/drivers-license)(\?|\/|#|$)/,
        ChatOrigins.ACQUISITION_ORIGIN_DRIVER_LICENSE_HOME,
      ],
      [
        /\/((acquisition|procurement)\/identity\/personal-details)(\?|\/|#|$)/,
        ChatOrigins.ACQUISITION_ORIGIN_IDENTITY_PERSONAL_DETAILS,
      ],
      [
        /\/((acquisition|procurement)\/review-order|dashboard|order-summary)(\?|\/|#|$)/,
        ChatOrigins.ACQUISITION_ORIGIN_REVIEW_ORDER,
      ],
      [
        /\/((acquisition|procurement)\/order-placed-dashboard)(\?|\/|#|$)/,
        ChatOrigins.ACQUISITION_ORIGIN_OPD,
      ],
      [
        /\/((acquisition|procurement)\/contracts\/finished)(\?|\/|#|$)/,
        ChatOrigins.ACQUISITION_ORIGIN_CONTRACTS_FINISHED,
      ],
      [
        /\/((acquisition|procurement)\/contracts\/save-progress)(\?|\/|#|$)/,
        ChatOrigins.ACQUISITION_ORIGIN_CONTRACTS_SAVE,
      ],
      [
        /\/((acquisition|procurement)\/contracts\/opt-out)(\?|\/|#|$)/,
        ChatOrigins.ACQUISITION_ORIGIN_CONTRACTS_OPTOUT,
      ],
      [
        /\/((acquisition|procurement)\/contracts\/error)(\?|\/|#|$)/,
        ChatOrigins.ACQUISITION_ORIGIN_CONTRACTS_ERROR,
      ],
      [
        /\/((acquisition|procurement)\/contracts)(\?|\/|#|$)/,
        ChatOrigins.ACQUISITION_ORIGIN_CONTRACTS_DEFAULT,
      ],
      [/\/((acquisition|procurement)\/error)(\?|\/|#|$)/, ChatOrigins.ACQUISITION_ORIGIN_ERROR],
      [
        /\/((acquisition|procurement)\/customer-order-dashboard\/delivery-details)(\?|\/|#|$)/,
        ChatOrigins.ACQUISITION_ORIGIN_CUSTOMER_DELIVERY_DETAILS,
      ],
      [
        /\/((acquisition|procurement)\/customer-order-dashboard\/documents-verifications)(\?|\/|#|$)/,
        ChatOrigins.ACQUISITION_ORIGIN_CUSTOMER_DOCUMENTS_VERIFICATIONS,
      ],
      [
        /\/((acquisition|procurement)\/customer-order-dashboard\/documents-verifications)(\?|\/|#|$)/,
        ChatOrigins.ACQUISITION_ORIGIN_CUSTOMER_SCHEDULE,
      ],
      [
        /\/((acquisition|procurement)\/payment-collection)(\?|\/|#|$)/,
        ChatOrigins.ACQUISITION_ORIGIN_PAYMENT,
      ],
      [
        /\/((acquisition|procurement)\/payment-options\/personal-details)(\?|\/|#|$)/,
        ChatOrigins.ACQUISITION_ORIGIN_PAYMENT_OPTIONS_PERSONAL_DETAILS,
      ],
      [
        /\/((acquisition|procurement)\/delivery-details)(\?|\/|#|$)/,
        ChatOrigins.ACQUISITION_ORIGIN_CUSTOMER_DELIVERY_DETAILS,
      ],
      [
        /\/((acquisition|procurement)\/documents-verifications)(\?|\/|#|$)/,
        ChatOrigins.ACQUISITION_ORIGIN_CUSTOMER_DOCUMENTS_VERIFICATIONS,
      ],
      [
        /\/((acquisition|procurement)\/down-payment)(\?|\/|#|$)/,
        ChatOrigins.ACQUISITION_ORIGIN_PAYMENT,
      ],
      [/\/((acquisition|procurement)\/error)(\?|\/|#|$)/, ChatOrigins.ACQUISITION_ORIGIN_ERROR],
      [
        /\/((acquisition|procurement)\/payment-options\/personal-details)(\?|\/|#|$)/,
        ChatOrigins.ACQUISITION_ORIGIN_PAYMENT_OPTIONS_PERSONAL_DETAILS,
      ],
      [
        /\/((acquisition|procurement)\/transfer-schedule)(\?|\/|#|$)/,
        ChatOrigins.ACQUISITION_ORIGIN_CUSTOMER_SCHEDULE,
      ],
      [
        /\/((acquisition|procurement)\/income-information)(\?|\/|#|$)/,
        ChatOrigins.UNDERWRITING_ORDER_INCOME,
      ],
      [/\/(acquisition|procurement)(\?|\/|#|$)/, ChatOrigins.ACQUISITION_ORIGIN_REVIEW_ORDER],
    ];
  }
  return [];
};
